import React from 'react';
import { Row, Col, Checkbox, Form, Input, Typography } from 'antd';

const { Text } = Typography;

const TabCustomFields = ({ customFields = [], form }) => {
    // Watch form changes in real time
    const selectedIds = Form.useWatch('CustomSeatFieldIds', form) || [];

    // Check and uncheck IDs
    const toggleGroup = (groupId, checked) => {
        let updated;
        if (checked) {
            if (selectedIds.length >= 2) return;
            updated = [...selectedIds, groupId];
        } else {
            updated = selectedIds.filter(id => id !== groupId);
        }
        form.setFieldsValue({ CustomSeatFieldIds: updated });
    };

    return (
        <>
            <Row style={{ marginBottom: 16 }}>
                <Col span={24}>
                    <Text type="secondary">
                        Configure up to 2 Custom Field Groups that will be displayed when a participant is scanned
                        on the devices assigned to this configuration.
                    </Text>
                </Col>
            </Row>

            <Row gutter={[16, 16]}>
                {customFields.map(group => {
                    const groupName = group.name?.[0]?.value || 'Unnamed Group';
                    const groupFields = group.participantCustomFields?.participantCustomField || [];

                    const isChecked = selectedIds.includes(group.id);
                    const disabled = !isChecked && selectedIds.length >= 2;

                    return (
                        <Col key={group.id} xs={24} sm={12} md={8} lg={6}>
                            <div style={{ border: '1px solid #eee', borderRadius: 8, padding: 12 }}>
                                <Checkbox
                                    checked={isChecked}
                                    disabled={disabled}
                                    onChange={(e) => toggleGroup(group.id, e.target.checked)}
                                >
                                    <strong>{groupName}</strong>
                                </Checkbox>

                                <ul style={{ marginTop: 8, marginBottom: 0, paddingLeft: 20 }}>
                                    {groupFields.map(field => (
                                        <li key={field.id}>{field.name}</li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                    );
                })}

                <Form.Item name="CustomSeatFieldIds" hidden>
                    <Input type="hidden" />
                </Form.Item>
            </Row>
        </>
    );
};

export default TabCustomFields;
